import React, { FC } from 'react'
import useGetCapitals from '@src/hooks/useGetCapitals'
import {
  BasicCard,
  getTrimmedExcerpt,
  Tag,
  SliderHeader,
  Button
} from '@islandsstofa/react'
import { Capital } from '@root/src/utils/resolvers'
import { Link } from 'gatsby'

interface Props {
  title?: string
  link_text?: string
  link_url?: string
  cards?: Capital[]
}

const CapitalSlider: FC<Props> = ({
  title = 'Missing title',
  link_text = 'Missing link text',
  link_url = '/',
  cards
}) => {
  // if cards are provided then use those... otherwise fetch all
  const capitals = cards ?? useGetCapitals()

  return (
    <section className='page-slice-spacer container'>
      <SliderHeader title={title}>
        <Link to={link_url}>
          <Button icon='arrowRight' type='secondary' label={link_text}></Button>
        </Link>
      </SliderHeader>
      <div className='card-grid'>
        {capitals.slice(0, 3).map((card, key) => (
          <Link key={key} to={card.url}>
            <BasicCard
              onRenderImage={() => (
                <img src={card.image.url} alt={card.image.alt} />
              )}
              variant='tall'
              onRenderFootnote={() => (
                <div>
                  {card.customTags.slice(0, 4).map((tag, idx) => {
                    return (
                      <Tag key={idx} type={idx === 0 ? 'transparent' : 'basic'}>
                        {tag}
                      </Tag>
                    )
                  })}
                </div>
              )}
            >
              <h4>{card.name.text}</h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: getTrimmedExcerpt('p', card.excerpt)?.html ?? ''
                }}
              />
            </BasicCard>
          </Link>
        ))}
      </div>
    </section>
  )
}

export default CapitalSlider
